/* eslint-disable import/no-named-as-default */
import VTooltip from "v-tooltip";
import Vue from "vue";

Vue.use(VTooltip);
